export class SavePermissionRequest {
  idValidationConfiguration: number;
  idAccessUser: number;
}
